// KPI card design tokens — the accent borders, watermark icon colours and icon
// glyphs shared by the house KPI card anatomy. Split out of KpiCard.js so a feature
// can reuse the PALETTE without importing the KpiCard component (and its recharts /
// InfoTip / DeltaBadge dependencies): KpiCard re-exports these for its existing
// callers, and MoneyStrip / MetricTile pull the tokens straight from here.
//
// This file renders no markup of its own — the glyphs are inert <path> fragments a
// caller drops into its own <svg>.

import React from 'react';

export const KPI_ACCENT_BORDERS = {
  primary: 'border-t-[#32B1FF] dark:border-t-[#32B1FF]',
  success: 'border-t-teal-400 dark:border-t-teal-500',
  muted: 'border-t-sky-400 dark:border-t-sky-500',
  subtle: 'border-t-indigo-400 dark:border-t-indigo-500',
  highlight: 'border-t-fuchsia-400 dark:border-t-fuchsia-500',
};
export const KPI_ICON_COLORS = {
  primary: 'text-[#32B1FF]/10 dark:text-[#32B1FF]/5',
  success: 'text-teal-400/10 dark:text-teal-500/5',
  muted: 'text-sky-400/10 dark:text-sky-500/5',
  subtle: 'text-indigo-400/10 dark:text-indigo-500/5',
  highlight: 'text-fuchsia-400/10 dark:text-fuchsia-500/5',
};
// Union of the Ads + GA4 icon sets. Shared keys (chart/dollar/conversions/percent)
// were identical byte-for-byte in both before the merge.
export const KPI_ICONS = {
  chart: (<> <path d="M4 20V10" /><path d="M10 20V4" /><path d="M16 20v-6" /><path d="M22 20H2" /> </>),
  dollar: (<> <path d="M12 2v20M17 5H9.5a3.5 3.5 0 000 7h5a3.5 3.5 0 010 7H6" /> </>),
  click: (<> <path d="M12 2a10 10 0 1 0 10 10" /><path d="M12 12l8-8" /><path d="M16 4h4v4" /> </>),
  target: (<> <circle cx="12" cy="12" r="10" /><circle cx="12" cy="12" r="6" /><circle cx="12" cy="12" r="2" /> </>),
  phone: (<> <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07 19.5 19.5 0 01-6-6A19.79 19.79 0 012.12 4.18 2 2 0 014.11 2h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L8.09 9.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 16.92z" /> </>),
  conversions: (<> <path d="M22 11.08V12a10 10 0 11-5.93-9.14" /><path d="M22 4L12 14.01l-3-3" /> </>),
  percent: (<> <line x1="19" y1="5" x2="5" y2="19" /><circle cx="6.5" cy="6.5" r="2.5" /><circle cx="17.5" cy="17.5" r="2.5" /> </>),
  booking: (<> <rect x="3" y="4" width="18" height="18" rx="2" ry="2" /><line x1="16" y1="2" x2="16" y2="6" /><line x1="8" y1="2" x2="8" y2="6" /><line x1="3" y1="10" x2="21" y2="10" /><path d="M8 14h.01M12 14h.01M16 14h.01M8 18h.01M12 18h.01" /> </>),
  users: (<> <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" /><circle cx="9" cy="7" r="4" /><path d="M23 21v-2a4 4 0 0 0-3-3.87" /><path d="M16 3.13a4 4 0 0 1 0 7.75" /> </>),
  bounce: (<> <path d="M9 17l-5 5" /><path d="M4 22l0-6 6 0" /><path d="M21 3a18 18 0 0 0-18 18" /> </>),
};
